import { Id } from "./id";

type Attachment = {
  attachmentType: "DOCUMENT" | "FOLDER";
  attachedEntityUuid: Id;
};

const attachment: Attachment = {
  attachmentType: "DOCUMENT",
  attachedEntityUuid: "",
};

export type { Attachment };

export { attachment };
